module.exports = __webpack_public_path__ + "static/media/TopMenu_Profile.8ee254ec.svg";